import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    reenableAfterSuccess: { type: Boolean, default: true },
  };

  connect() {
    this.form = this.element.querySelector('form');

    if (this.form) {
      this.form.addEventListener(
        'ajax:beforeSend',
        this.handleBeforeSubmit.bind(this)
      );
      this.form.addEventListener('ajax:success', this.handleSuccess.bind(this));
      this.form.addEventListener('ajax:error', this.handleError.bind(this));

      this.submitButton = Array.from(this.form.querySelector('[type=submit]'));
      this.formElements = Array.from(
        this.form.querySelectorAll(
          'input:not([type=submit]), button:not([type=submit])'
        )
      );
    }
  }

  handleBeforeSubmit() {
    this.toggleDisabledState(true);
  }

  handleSuccess() {
    if (this.reenableAfterSuccessValue) {
      this.toggleDisabledState(false);
    }
  }

  handleError() {
    this.toggleDisabledState(false);
  }

  toggleDisabledState(isDisabled) {
    this.formElements.forEach((element) => (element.disabled = isDisabled));
  }
}
